import MuiAccordionDetails, { AccordionDetailsProps } from "@mui/material/AccordionDetails";

const AccordionDetails: React.FC<AccordionDetailsProps> = MuiAccordionDetails;

export default AccordionDetails;
export type { AccordionDetailsProps };